import { useContext } from "react";
import Legend from "@arcgis/core/widgets/Legend";
import LayerList from "@arcgis/core/widgets/LayerList";
import TextSymbol from "@arcgis/core/symbols/TextSymbol";
import { Box, Tooltip } from "@mui/material";

export const LegendOverlay = (view: any, container: any) => {
  console.log("legend");
  const textSymbol = new TextSymbol({
    color: "#7A003C",
    text: "\ue61d", // esri-icon-map-pin
    font: {
      // autocast as new Font()
      size: 24,
      family: "CalciteWebCoreIcons",
    },
  });

  new Legend({ respectLayerVisibility: false });

  const hideLayers = [
    "Base layers",
    "Custom Prioritization",
    "walk layer",
    "Park with public access",
    "ParkServe Urban Area",
    "ParkServe Place",
    "ParkServe Cities and Towns",
    "Park and Trail Sketch",
    "10-minute walk service area",
    "Priority areas for new parks (place)",
    "Priority areas for new parks (Urban Area)",
  ];

  const layerListWidget = new LayerList({
    view: view,
    container: "legend-box",
    listItemCreatedFunction: (event) => {
      const item = event.item;
      if (hideLayers.includes(item.layer.title)) {
        item.layer.listMode = "hide";
      } else {
        if (item.layer.type != "group") {
          if (!item.layer.title.toLowerCase().includes("urban heat island")) {
            item.panel = {
              content: "legend",
              open: true,
              actionsOpen: true,
            };
          }
        }
      }
    },
  });
};
